import FlexColumn from "common/components/styled-components/FlexColumn";
import { CalculatorResult } from "features/auth/types";
import StackedBar from "./StackedBar";

interface GlobalProps {
  result: CalculatorResult;
}

function Global({ result }: GlobalProps) {
  return (
    <FlexColumn gap={14}>
      <StackedBar
        title="Movilidad"
        averageValue={result.averageFootprint.transport}
        averageColor="#a6be0a"
        userValue={result.userFootprint.transport}
        userColor="#dde393"
        total={Math.max(
          result.averageFootprint.total,
          result.userFootprint.total
        )}
      />
      <StackedBar
        title="Energía"
        averageValue={result.averageFootprint.energy}
        averageColor="#306ba5"
        userValue={result.userFootprint.energy}
        userColor="#809fdb"
        total={Math.max(
          result.averageFootprint.total,
          result.userFootprint.total
        )}
      />
      <StackedBar
        title="Alimentación"
        averageValue={result.averageFootprint.nutrition}
        averageColor="#e37222"
        userValue={result.userFootprint.nutrition}
        userColor="#f6a66d"
        total={Math.max(
          result.averageFootprint.total,
          result.userFootprint.total
        )}
      />
      <StackedBar
        title="Hábitos de hogar"
        averageValue={result.averageFootprint.householdHabits}
        averageColor="#e8153b"
        userValue={result.userFootprint.householdHabits}
        userColor="#eb7187"
        total={Math.max(
          result.averageFootprint.total,
          result.userFootprint.total
        )}
      />
    </FlexColumn>
  );
}

export default Global;
